import { CCError, classifyError } from "./errors";

let worker = null;
const pending = new Set();

function getWorker() {
  if (!worker) worker = new Worker(`${process.env.PUBLIC_URL || ""}/whisper-worker.js`, { type: "module" });
  return worker;
}

export function resetWorker(reason = "Stopped") {
  if (worker) worker.terminate();
  worker = null;
  pending.forEach((rej) => rej(new CCError("CANCELLED", reason)));
  pending.clear();
}

function call(msg, onDownload, transfer = []) {
  return new Promise((resolve, reject) => {
    const w = getWorker();
    const cleanup = () => {
      w.removeEventListener("message", onMsg);
      w.removeEventListener("error", onErr);
      pending.delete(reject);
    };
    const onMsg = ({ data }) => {
      if (data.type === "download") return onDownload && onDownload(data);
      cleanup();
      if (data.type === "error") reject(new CCError(classifyError(data.message), data.message));
      else resolve(data);
    };
    const onErr = (e) => {
      cleanup();
      const m = e.message || "Engine failed to start (could not load Transformers.js or ran out of memory).";
      reject(new CCError(e.message ? classifyError(m) : "NETWORK", m));
      resetWorker();
    };
    pending.add(reject);
    w.addEventListener("message", onMsg);
    w.addEventListener("error", onErr);
    w.postMessage(msg, transfer);
  });
}

export const loadModel = (cfg, onDownload) =>
  call({ type: "load", model: cfg.model, device: cfg.device, dtype: cfg.dtype }, onDownload);

export const transcribeChunk = (audio, language, id, words) =>
  call({ type: "transcribe", audio, language, id, words }, null, [audio.buffer]);
